import { defineNuxtPlugin } from '#app';
import posthog from 'posthog-js';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const posthogClient = posthog.init(runtimeConfig.public.posthog.publicKey, {
    api_host: runtimeConfig.public.posthog.host,
    person_profiles: 'identified_only',
    capture_pageview: true,
    loaded: (posthog) => {
      if (runtimeConfig.public.mode === 'development') posthog.debug();
    },
  });

  const router = useRouter();
  router.afterEach((to) => {
    nextTick(() => {
      posthog.capture('$pageview', {
        name: to.name,
        current_url: to.fullPath,
      });
    });
  });

  return {
    provide: {
      posthog: posthogClient,
    },
  };
});
